import { Users, Lightbulb, Award, ShieldCheck } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    { icon: Lightbulb, title: "Innovation First", description: "We embrace new ideas and technologies to stay ahead of the curve." },
    { icon: Users, title: "Collaboration", description: "We believe the best solutions come from working together." },
    { icon: Award, title: "Excellence", description: "We maintain the highest standards in everything we deliver." },
    { icon: ShieldCheck, title: "Integrity", description: "We build trust through transparency and ethical practices." }
]

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-24">
            <div className="text-center  mb-12">
                <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-3">
                    Our Values
                </h3>
                <p className="md:text-lg text-gray-300 max-w-2xl mx-auto">
                    These principles guide everything we do and shape our company culture.
                </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}